import React from "react";

export default function RegulerInformationArea() {
  return (
    <div className="container-info mt-3">
      <div style={{ fontSize: 14, fontWeight: "600" }}>Keterangan</div>
      <div style={{ marginTop: 24 }}>
        <div className="d-flex">
          <div style={{ flex: 1 }}>1.</div>
          <div style={{ flex: 20 }}>
            Untuk 1 outlet membutuhkan 1 juru Taksir untuk masing-masing
            kategori produk.
          </div>
        </div>
      </div>
    </div>
  );
}
